import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Children, cloneElement, useContext } from 'react';
import rejectNilChildren from '../../../../utils/rejectNilChildren';
import { TableContext } from '../../Table';
const TableRow = ({ className, children, isHead, isLast, columnDescriptor, onResponsiveClick, rowOrder, descriptor, responsiveMode, disabled, ...other })=>{
    const { registerHeader } = useContext(TableContext);
    if (!children) {
        return /*#__PURE__*/ React.createElement("tr", {
            className: cx('Table-row', className, {
                'Table-row--disabled': disabled
            }),
            ...other
        });
    }
    const withDescriptor = (child, index)=>/*#__PURE__*/ cloneElement(child, {
            descriptor: columnDescriptor?.colSpec?.[index]
        });
    children = rejectNilChildren(children);
    // if row is inside header, notify the table how many columns the header has
    if (isHead && !columnDescriptor) {
        const colSpec = [];
        let totalWidth = 0;
        const colCount = Children.count(children);
        Children.forEach(children, (child, index)=>{
            let colWidth = 100;
            const isLast = index === colCount - 1;
            if (child.props.width && child.props.width === +child.props.width) {
                colWidth = +child.props.width;
            }
            totalWidth += colWidth;
            colSpec.push({
                visible: true,
                width: colWidth,
                span: child.props.colSpan || 1,
                order: index,
                priority: child.props.responsivePriority || (isLast ? 20 : 10),
                title: child.props.children
            });
        });
        registerHeader({
            cols: colCount,
            colSpec,
            totalWidth
        }, isLast);
    }
    if (columnDescriptor) {
        children = Children.map(children, withDescriptor);
    }
    return /*#__PURE__*/ React.createElement("tr", {
        className: cx('Table-row', className, {
            'Table-row--disabled': disabled
        }),
        ...other
    }, children);
};
TableRow.propTypes = {
    /**
	 * Children will be rendered within the `TableRow`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    columnDescriptor: PropTypes.object,
    /**
	 * If true, the row will be disabled.
	 */ disabled: PropTypes.bool,
    isHead: PropTypes.bool,
    isLast: PropTypes.bool,
    onResponsiveClick: PropTypes.any,
    rowOrder: PropTypes.any
};
TableRow.displayName = 'TableRow';
export default TableRow;
